import React, { useState, useEffect } from "react";
import { Table } from "react-bootstrap";
import Lightbox from "react-awesome-lightbox";
import "react-awesome-lightbox/build/style.css";
import { useGetSellerAddressInfoQuery } from "./common/ProcurementApiSlice";
import { Typography, Divider } from "@mui/material";

const StockLocationDetails = ({ stockId }) => {
  const { data: addressAll } = useGetSellerAddressInfoQuery(stockId);
  const [addressData, setAddressData] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedMedia, setSelectedMedia] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    setAddressData(addressAll?.data);
  }, [addressAll]);

  const handleImageClick = (media, index) => {
    setSelectedMedia(media);
    setCurrentIndex(index);
    setIsOpen(true);
  };

  const getImageUrls = (mediaArray) => {
    return mediaArray.map((media) => ({ url: media.file, title: media.title }));
  };

  return (
    <>

               <Typography variant="h5" sx={{ fontWeight: "bold" }}>Stock Location:</Typography>
     
        <Table striped hover className="" responsive>
          <thead>
            <tr>
              <th className="th-sm">Img</th>
              <th className="th-sm">Warehouse Name</th>
              <th className="th-sm">Qty</th>

              <th className="th-sm">State</th>
              <th className="th-sm">District</th>
              <th className="th-sm">Address</th>
              <th className="th-sm">Pincode</th>
            </tr>
          </thead>
          <tbody>
            {addressData?.map((field, index) => (
              <tr key={index}>
                <td>
                  <img
                    src={field?.all_media[0]?.file} // Assuming first image is displayed as thumbnail
                    alt={field?.media}
                    style={{
                      height: "30px",
                      width: "30px",
                      borderRadius: "50%",
                      border: "2px solid #ddd",
                      objectFit: "cover",
                      cursor: "pointer",
                    }}
                    onClick={() => handleImageClick(field.all_media, 0)}
                  />
                </td>
                <td>{field.warehouse_name}</td>
                <td>
                  {field.quantity} {field.unit_measurement}
                </td>
                <td>{field.state}</td>
                <td>{field.district}</td>
                <td>{field.address}</td>
                <td>{field.pincode}</td>
               
              </tr>
            ))}
          </tbody>
        </Table>

      {isOpen && (
        <Lightbox
          images={getImageUrls(selectedMedia)}
          startIndex={currentIndex}
          onClose={() => setIsOpen(false)}
        />
      )}
    </>
  );
};

export default StockLocationDetails;
